services.service('IntercomService', [
    '$q', 'config',
    function ($q, config) {

        var isEnabledIntegration = config['intercomIntegration'];

        if (!isEnabledIntegration) {
            console.warn('Intercom services are disabled');
        }

        this.init = function(){
            if(!isEnabledIntegration) {
                return;
            }

            var APP_ID = config['intercomAppId'];

            window.intercomSettings = {
                app_id: APP_ID,
                hide_default_launcher: true,
            };

            (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/' + APP_ID;var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s, x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();

        }

        this.sendUserDetails = function(user){
            if(!isEnabledIntegration) {
                return;
            }

            Intercom('boot', {
                email: user.email,
                user_hash: user.intercomHash,
                name: user.firstName,
            });
        }

        this.show = function () {
            if(!isEnabledIntegration) {
                return;
            }
            Intercom('show');
        }

        this.shutdown = function () {
            if(!isEnabledIntegration) {
                return;
            }
            Intercom('shutdown');
        }

        return this;
    }
]);
